import React from 'react';
import moment from 'moment';
import { Icon, Tooltip, Dropdown } from 'antd';
import { get } from 'lodash';
import P from '../../../../components/P';
import Tag from '../../../../components/Tag';
import GarageInfo from '$app/shared/components/GarageInfo/GarageInfo';
import InviteMenu from './InviteMenu/index';
import Markup from '../../WorkDetails/components/WorkDetailsTable/Markup';
import { dropdownStyling } from '../styled';

const tagColour = (val, hasNewTimes) => {
  if (val === 'cancelled' && hasNewTimes) {
    return '#ffa401';
  }

  switch (val) {
    case 'accepted':
      return '#3be6b1';
    case 'cancelled':
      return '#808080';
    case 'expired':
      return '#808080';
    case 'declined':
      return '#808080';
    default:
      return undefined;
  }
};

export default function ({ garageInvites, booking }) {
  return [
    {
      title: 'Garage Info',
      children: [
        {
          title: 'Candidate',
          key: 'candidateNumber',
          dataIndex: 'candidateNumber',
        },
        {
          title: 'Name',
          key: 'garage',
          dataIndex: 'garage.businessName',
          render: (val, invitation) => {
            const garage = get(invitation, 'garage', {});
            return <GarageInfo garage={garage} />;
          },
        },
        {
          title: 'Distance',
          key: 'distance',
          width: '10%',
          render: (val, invitation) => {
            const displayMileOrDash = (dist) =>
              dist > 0 || dist === 0 ? `${Math.round(dist * 10) / 10}mi` : '-';

            return displayMileOrDash(invitation.collectionDistance);
          },
        },
        {
          title: 'Capacity',
          render: (val, invitation) => {
            const { currentAllocation, maxAllocation, currentCnd, maxCnd } = invitation;

            const allocationCapacityClass = currentAllocation >= maxAllocation ? 'full-capacity' : '';
            const cndCapacityClass = currentCnd >= maxCnd ? 'full-capacity' : '';

            return (
              <>
                <span className={allocationCapacityClass}>
                  {currentAllocation}/{maxAllocation} Allocation
                </span>
                <br />
                <span className={cndCapacityClass}>
                  {currentCnd}/{maxCnd} C&D
                </span>
              </>
            );
          },
        },
      ],
    },
    {
      title: 'Invite Info',
      children: [
        {
          title: 'Markup',
          key: 'total',
          width: '10%',
          render: (val, invitation) => {
            const garagePrice = invitation.priceWithVat;
            const customerPrice = booking.quote.customerTotalPriceWithVAT;
            return <Markup garageCostWithVat={garagePrice} fixedCostWithVAT={customerPrice} />;
          },
        },
        {
          title: 'C&D',
          key: 'collectionDeliveryOption',
          dataIndex: 'collectionDeliveryOption',
          width: '8%',
          render: (cndType) => {
            if (cndType === 'GarageC&D') return <P>Garage</P>;
            if (cndType === 'CustomerC&D') return <P>Customer</P>;
            return <P>{cndType}</P>;
          },
        },
        {
          title: 'Status',
          key: 'status',
          dataIndex: 'status',
          render: (val, invitation) => {
            const hasNewTimes = invitation?.proposedChanges?.length > 0;

            const getTagLabel = () => {
              if (val === 'review') return 'declined with new time';
              if (val === 'cancelled' && hasNewTimes) return 'cancelled with new time';
              return val;
            };

            return (
              <Tooltip placement="top" title={invitation.rejectionNote}>
                <Tag className={invitation.status} color={tagColour(val, hasNewTimes)} key={val}>
                  {getTagLabel()}
                </Tag>
              </Tooltip>
            );
          },
        },
        {
          title: 'Garage note',
          key: 'garageNote',
          render: (val, invitation) => {
            if (!invitation.rejectionNote) return '';
            return (
              <Tooltip placement="top" title={invitation.rejectionNote}>
                <span className="view-hover">
                  <Icon type="eye" /> view
                </span>
              </Tooltip>
            );
          },
        },
        {
          title: 'Date',
          key: 'creationDateTime',
          dataIndex: 'creationDateTime',
          render: (val, invitation) => <P>{moment(invitation.creationDateTime).format('DD/MM/YY HH:mm')}</P>,
        },
        {
          title: 'Customer note',
          key: 'customerNote',
          render: (val, invitation) => {
            if (!invitation.notes) return '';
            return (
              <Tooltip placement="top" title={invitation.notes}>
                <span className="view-hover">
                  <Icon type="eye" /> view
                </span>
              </Tooltip>
            );
          },
        },
        {
          key: 'menu',
          title: '',
          className: 'menu',
          render: (val, invitation) => (
            <Dropdown
              trigger={['click']}
              overlay={
                <InviteMenu
                  invitation={invitation}
                  booking={booking}
                  garageInvites={garageInvites}
                />
              }
              overlayStyle={dropdownStyling}
            >
              <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                <Icon type="menu" />
              </a>
            </Dropdown>
          ),
        },
      ],
    },
  ];
}
